import React from 'react'
import CreateStarChartHeaderPresentation from '../../presentation/createStarChart/CreateStarChartHeaderPresentation'
import { CreateStarChartHeaderPresentationProps } from '../../types/types'



const CreateStarChartHeaderContainer: React.FC<CreateStarChartHeaderPresentationProps> = ({starChartName,setStarChartName}) => {

  return (
    <CreateStarChartHeaderPresentation starChartName={starChartName} setStarChartName={setStarChartName}/>
  )
}

export default CreateStarChartHeaderContainer
